import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import { useTranslation } from "react-i18next";

export default function Privacy() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">
            {t("privacy.title")}
          </h1>

          <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
            <div>
              <p className="text-gray-600 mb-6">{t("privacy.lastUpdated")}</p>
              <p className="text-gray-700 leading-relaxed">
                {t("privacy.intro")}
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t("privacy.section1.title")}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t("privacy.section1.content")}
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>{t("privacy.section1.item1")}</li>
                <li>{t("privacy.section1.item2")}</li>
                <li>{t("privacy.section1.item3")}</li>
                <li>{t("privacy.section1.item4")}</li>
                <li>{t("privacy.section1.item5")}</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t("privacy.section2.title")}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t("privacy.section2.content")}
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>{t("privacy.section2.item1")}</li>
                <li>{t("privacy.section2.item2")}</li>
                <li>{t("privacy.section2.item3")}</li>
                <li>{t("privacy.section2.item4")}</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t("privacy.section3.title")}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t("privacy.section3.content")}
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t("privacy.section4.title")}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t("privacy.section4.content")}
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>{t("privacy.section4.item1")}</li>
                <li>{t("privacy.section4.item2")}</li>
                <li>{t("privacy.section4.item3")}</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t("privacy.section5.title")}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t("privacy.section5.content")}
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t("privacy.section6.title")}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t("privacy.section6.content")}
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t("privacy.section7.title")}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t("privacy.section7.content")}
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700">
                  <strong>{t("privacy.contact.company")}</strong> AUTOCHAIN
                </p>
                <p className="text-gray-700">
                  <strong>{t("privacy.contact.email")}</strong>{" "}
                  info@autochain.com.hk
                </p>
                <p className="text-gray-700">
                  <strong>{t("privacy.contact.phone")}</strong> +852 9425 2903
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
